var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectionArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_305_4874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9248 12.75L12.7583 10.5835L13.5054 9.83643L16.9502 13.2812L13.5054 16.7261L12.7583 15.979L14.9248 13.8125L-1.27356e-07 13.8125L-1.738e-07 12.75L14.9248 12.75ZM12.7583 2.0835L13.5054 1.33643L16.9502 4.78125L13.5054 8.22607L12.7583 7.479L14.9248 5.3125L-4.98903e-07 5.3125L-5.45347e-07 4.25L14.9248 4.25L12.7583 2.0835Z",
    fill: "#672EBB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_305_4874"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(0 17) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectionArrow);
export default __webpack_public_path__ + "static/media/selection-arrow.3dbdf6627c1895565028cc138e40736c.svg";
export { ForwardRef as ReactComponent };